
  <mb-dialog-header>
    <h3 class="dialog-header-title" i18n="@@disney_purchase_policy_dialog_title">
      Nuevos pasos a seguir para reservar hoteles de Walt Disney World Resort Orlando:
    </h3>
  </mb-dialog-header>
  <mb-dialog-body>
    <div class="body-container">
      <div class="steps">
        <div class="step">
          <div class="step__body">
            <h6><span i18n="@@disney_purchase_policy_dialog_step_title">Paso</span> 1</h6>
            <img [src]="firstStepImage" class="step__body--image" />
            <p i18n="@@disney_purchase_policy_dialog_first_step_body">
              Antes de comprar, verifica la disponibilidad de reservaciones en el sitio
              web oficial de Walt Disney World Resort para las fechas en las que quieras
              ir a los parques.
            </p>
            <p class="step__body--link">
              <a
                [href]="dispoLink"
                target="_blank"
                i18n="@@disney_purchase_policy_dialog_dispo_link"
                >Ver disponibilidad</a
              >
            </p>
          </div>
        </div>
        <div class="step">
          <div class="step__body">
            <h6><span i18n="@@disney_purchase_policy_dialog_step_title">Paso</span> 2</h6>
            <img [src]="secondStepImage" class="step__body--image" />
            <p i18n="@@disney_purchase_policy_dialog_second_step_body">
              Una vez que te aseguraste que hay disponibilidad en las fechas deseadas, ya
              podes comprar tus tickets y hotel de Disney con nosotros.
            </p>
          </div>
        </div>
      </div>
      <div class="steps">
        <div class="step">
          <div class="step__body">
            <h6><span i18n="@@disney_purchase_policy_dialog_step_title">Paso</span> 3</h6>
            <img [src]="thirdStepImage" class="step__body--image" />
            <p i18n="@@disney_purchase_policy_dialog_third_step_body">
              Luego de realizada la compra, tenés que vincular el Nº de ticket que
              figurará en tu voucher y reservar tus entradas a los parques. <br />
              Te recomendamos que este paso lo realices
              <strong>inmediatamente luego de tu compra</strong>, ya que deberás reservar
              día por día el ingreso a cada parque (sin esta confirmación no podrás
              ingresar a los mismos).<br />
              Podrás cambiar, cancelar, y tomar nuevamente las reservas hasta 48hs antes
              de tu fecha de ingreso, pero será <strong>sujeto a disponibilidad.</strong>
            </p>
            <p class="step__body--link">
              <a
                [href]="attachTicketsLink"
                target="_blank"
                i18n="@@disney_purchase_policy_dialog_attach_ticket_link"
                >Vincular tickets a la reserva</a
              >
            </p>
          </div>
        </div>
        <div class="step">
          <div class="step__body">
            <h6><span i18n="@@disney_purchase_policy_dialog_step_title">Paso</span> 4</h6>
            <img [src]="fourthStepImage" class="step__body--image" />
            <p i18n="@@disney_purchase_policy_dialog_fourth_step_body">
              Si después de realizar los pasos anteriores tenes más dudas, podrás
              consultar toda la información actualizada sobre los protocolos de viajes en
              el siguiente link.
            </p>
            <p class="step__body--link">
              <a
                [href]="officialSiteLink"
                target="_blank"
                i18n="@@disney_purchase_policy_dialog_official_site_link"
                >Ir al sitio oficial de Disney</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </mb-dialog-body>
  <mb-dialog-footer>
    <div class="footer-container">
      <button
        mb-button
        variant="principal"
        color="primary"
        (click)="dialog.close()"
        class="footer-container__button"
      >
        <span i18n="@@disney_purchase_policy_dialog_accept">ACEPTAR</span>
      </button>
    </div>
  </mb-dialog-footer>

